import { render, staticRenderFns } from "./customerEditor.vue?vue&type=template&id=649ab3a6&"
import script from "./customerEditor.vue?vue&type=script&lang=js&"
export * from "./customerEditor.vue?vue&type=script&lang=js&"
import style0 from "./customerEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649ab3a6')) {
      api.createRecord('649ab3a6', component.options)
    } else {
      api.reload('649ab3a6', component.options)
    }
    module.hot.accept("./customerEditor.vue?vue&type=template&id=649ab3a6&", function () {
      api.rerender('649ab3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/customerEditor.vue"
export default component.exports